export default __webpack_public_path__ + "static/media/elearning.5f0e8e9b.png";